import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    padding: "0 16px",

    "& .head-title": { color: "#2A3790", fontWeight: "600" },
  },

  cardHeadSelect: {
    background: "#ECF8FD",
    marginTop: "12px",
    padding: "24px",
    borderRadius: "12px",
  },

  divInput: {
    "& .input": {
      padding: "6px 6px 6px 0",
      width: "100%",

      "&:before": { borderBottom: "none !important" },
      "&:after": { borderBottom: "none !important" },
    },

    "& .border": {
      display: "flex",
      border: "1px solid #2A3790",
      borderRadius: "8px",
      padding: "0 8px",
    },
  },

  label: {
    display: "flex",
    width: "100%",
    marginBottom: "6px",
    paddingLeft: "6px",
  },

  buttonSearch: {
    width: "100%",
    maxWidth: "260px",
    background: "#2A3790 !important",
    color: "white !important",

    "&:hover": {
      background: "#2A3790 !important",
    },

    "& .img": {
      marginRight: "12px",
    },
  },

  select: {
    padding: "6px 0",
    background: "#ECF8FD",

    "& .MuiSelect-select.MuiSelect-outlined": {
      paddingTop: "4px",
      paddingBottom: "5px",
      paddingLeft: 0,
      border: "none",
    },

    "& .MuiOutlinedInput-notchedOutline": {
      display: "none",
    },
  },

  selectPage: {
    paddingLeft: "6px",
    width: "150px",
    border: "1px solid #2A3790",
    borderRadius: "8px",
    display: "flex",
    height: "35px",

    "& .select-number": {
      "& .MuiSelect-select.MuiSelect-outlined": {
        paddingTop: "4px",
        paddingBottom: "5px",
        paddingLeft: 0,
        border: "none",
      },

      "& .MuiOutlinedInput-notchedOutline": {
        display: "none",
      },
    },
  },

  boxTable: {
    marginTop: "16px",

    "& .head": {
      display: "flex",
      justifyContent: "space-between",

      "& .button-table": {
        display: "flex",
      },
    },

    "& .head-title": {
      fontSize: "20px",
    },

    "& .button": {
      border: "1px solid #2A3790",
      borderRadius: "8px",
      marginLeft: "12px",
      display: "flex",
      alignItems: "center",
      padding: "0 6px",

      "& .MuiButtonBase-root.MuiButton-root": {
        padding: "0",
        color: "#2A3790",
      },
    },
  },

  div: {
    overflowX: "auto",
  },

  table: {
    marginTop: "20px",
    minWidth: "1358px",

    "& .sticky": {
      position: "sticky",
    },

    "& thead th": { color: "#2A3790 !important" },

    "& thead .stt": { width: "50px" },

    "& thead .date": { width: "140px" },

    "& thead .show": { width: "120px", right: 0 },

    "& tbody .odd": {
      backgroundColor: "white",
    },

    "& th.merchant": {
      width: "120px",
    },

    "& th": {
      textAlign: "center",
    },

    "& tbody .show": {
      textAlign: "center",
      right: 0,
      background: "white",
    },

    "& tbody .color2": {
      color: "#26A9E0",
    },

    "& tbody .color4": {
      color: "#FB7800",
    },

    "& tbody .color5": {
      color: "#39B44A",
    },

    "& tbody .color7": {
      color: "#BF272D",
    },

    "& td": {
      textAlign: "center",
    },
  },

  footer: {
    "& .MuiPagination-root": {
      "& .MuiButtonBase-root.Mui-selected": {
        color: "#2A3790",
        border: "1px solid #2A3790",
        backgroundColor: "rgba(89, 136, 255, 0.12)",
      },
    },
  },

  infor: {
    background: "#EBFFFE",
  },

  document: {
    background: "#FFFFE7",
    // height: "calc(100% - 240px)",
    padding: "12px",
    flex: 1,

    "& .headDocument": {
      display: "flex",
      justifyContent: "space-between",
      color: "#284078",
      fontSize: "16px",
      fontWeight: "600",
    },
  },

  history: {
    background: "#EBFFFE",
    height: "100%",

    "& .head-history": {
      padding: "12px 24px",
      color: "#284078",
      fontSize: "18px",
      fontWeight: "600",
    },

    "& .form-infor": {
      display: "flex",
      alignItems: "start",
      background: "white",
      padding: "8px",
      fontSize: "14px",

      "& .inline": {
        margin: "8px 0",

        "& .title": {
          color: "#284078",
          fontWeight: "600",
        },

        "& img": {
          marginRight: "4px",
          width: "20px",
          height: "20px",
        },

        "& .border-none": {
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiInputBase-multiline": {
            padding: "0 10px !important",
          },
        },

        "& .MuiInputBase-multiline": {
          padding: "10px !important",
          fontSize: 14,
        },
      },
    },
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    "& .button": {
      color: "white",
      background: "#2A3790",
      width: "200px",
      borderRadius: "32px",
      margin: "20px",
    },

    "& .disabled": {
      opacity: 0.3,
    },
  },

  accordionRoot: {
    background: "#EBFFFE",
    boxShadow: "none",
    minHeight: "38px",
    margin: "0",

    "&:before": { backgroundColor: "#EBFFFE" },

    "& .MuiAccordionSummary-root": {
      minHeight: "38px",
    },

    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "0",
    },

    "& .MuiButtonBase-root.MuiAccordionSummary-root": {
      padding: "0 12px",
    },

    "& .MuiAccordionDetails-root": {
      padding: "0px 12px",
    },

    "& .titleAccodion": {
      color: "#284078",
      fontSize: "18px",
      fontWeight: "600",
    },

    "& .code": {
      "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
      },
    },
  },

  boxAccor: {
    background: "#EBFFFE",
    padding: "0 0 12px 0",

    "& .Mui-expanded": {
      margin: "0 0 4px 0",
    },

    "& .rowDiv": {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",
      // fontWeight: "500",
      margin: "12px 0 4px",
      // paddingBottom: "6px",

      "& .titleSpan": {
        color: "#2A3790",
        whiteSpace: "nowrap",
        marginRight: "6px",
      },
    },

    "& .capitalize": {
      textTransform: "capitalize",
    },
  },

  boxImg: {
    width: "100%",
    margin: "12px 0",
    // overflowX: "auto",

    "& .title": {
      color: "#2A3790",
      fontWeight: "600",
      marginBottom: "12px",
      left: 0,
      position: "sticky",
    },

    "& .div-img": {
      overflowX: "auto",
      maxWidth: "100%",
      // width: "fit-content",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      gap: 8,
    },

    "& .img": {
      marginRight: "12px",
      // width: "110px",
      height: "90px",
      display: "flex",
      alignItems: "center",
      background: "white",
      minWidth: "20%",
    },

    "& .button": {
      background: "#E4E7EB",
      color: "black",
      fontWeight: 400,
      padding: "5px 15px",
    },

    "& .bg-gray": {
      padding: 10,
      background: "#F8F9FA",
    },

    "& .row": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },

    "& .border": {
      borderBottom: "1px solid #EDEDED",
      padding: "10px 0",
    },

    "& .cursor:hover": {
      cursor: "pointer",
      color: "#2A3790",
      fontWeight: 500,
    },

    "& .size": {
      fontSize: 12,
    },

    "& .not-have-img": {
      margin: "12px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      color: "red",
      fontStyle: "italic",
    },

    "& .video-box": {
      minWidth: 230,
      minHeight: 130,
      borderRadius: 10,
      marginRight: 5,
    },

    "& .video-name": {
      textAlign: "center",
      fontSize: 12,
      color: "#343A40",
      marginTop: 5,
    },
  },

  boxLine: {
    padding: "0 12px",

    "& .lineTitle": {
      marginTop: "20px",
      color: "#284078",
      fontSize: "18px",
      fontWeight: "600",
    },
  },

  button: {
    color: "#2A3790",
    width: "200px",
    border: "2px solid #2A3790",
    borderRadius: "32px",
    margin: "20px",
  },

  date: {
    "& .MuiInputBase-root": {
      background: "#eaf8fd",
      height: "46px",
    },

    "& .MuiInputBase-input": {
      padding: "13px",
    },

    "& .MuiOutlinedInput-notchedOutline": {
      display: "none",
    },
  },

  additional_img: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "8px",
    border: "1px solid #284078",
    borderRadius: "12px",
    width: "110px",
    marginRight: "8px",
    marginBottom: "6px",
    position: "relative",
    height: "90px",

    "& .spanPicture": {
      color: "#284078",
      textAlign: "center",
      fontWeight: "500",
      fontSize: "14px",
    },

    "& .icon": {
      position: "absolute",
      top: 0,
      right: 0,
    },
  },

  exportButton: {
    padding: "2px",
    margin: "15px 0",
    display: "flex",
    justifyContent: "space-around",

    "& .bt-show": {
      padding: "6px",
      background: "#1A427D",
      color: "white",
      fontSize: " 14px",
    },
  },

  boxLicense: {
    width: "100%",
    margin: "12px 0",

    "& .title": {
      color: "#2A3790",
      fontWeight: "600",
      marginBottom: "12px",
    },
    "& .p-10": {
      padding: 10,
    },
    "& .box-audio": {
      background: "#fff",
    },
    "& .row": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    "& .button": {
      background: "#E4E7EB",
      color: "black",
      fontWeight: 400,
      padding: "5px 15px",
    },
    "& .bg-gray": {
      padding: 10,
      background: "#F8F9FA",
    },
    "& .border": {
      padding: "8px 0",
      borderBottom: "1px solid #E9ECEF",
    },
    "& .fs-14": {
      fontSize: 14,
    },
    "& .size": {
      fontSize: 13,
      fontStyle: "italic",
    },
    "& .icon": {
      margin: 8,
    },
  },

  accordionUpdate: {
    background: "#FFF",
    boxShadow: "none",
    minHeight: "38px",
    margin: "0",

    "&:before": { backgroundColor: "#FFF" },

    "& .MuiAccordionSummary-root": {
      minHeight: "38px",
    },

    "& .MuiAccordionSummary-content.Mui-expanded": {
      padding: "12px 0",
      margin: 0,
    },

    "& .MuiButtonBase-root.MuiAccordionSummary-root": {
      padding: "0 12px",
    },

    "& .MuiAccordionDetails-root": {
      padding: "0 12px",
    },

    "& .accordion-title": {
      color: "#284078",
      fontSize: "18px",
      fontWeight: "600",
    },
  },

  updatedHistory: {
    padding: "10px 0px 20px",
    "& .title-1": {
      color: "#284078",
      fontWeight: "600",
      fontSize: 18,
      margin: "8px 0 0 12px",
    },
    "& .border": {
      margin: "8px 0",
      padding: 12,
      fontSize: 14,
      background: "#FFFFE7",
      borderRadius: 10,
      border: "0.5px solid #D2D2D2",
      // transition: "all 0.3s linear"
    },
    "& .row": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 8,
    },
    "& .time": {
      color: "#969696",
      fontSize: 12,
    },
    "& .show": {
      display: "flex",
      color: "#003478",
      fontSize: 12,
      "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
      },
    },
    "& .inline": {
      margin: "8px 0",
      "& .title-2": {
        color: "#284078",
        fontWeight: "600",
        fontSize: 14,
      },
      "& img": {
        marginRight: "4px",
        width: "20px",
        height: "20px",
      },
    },
  },
}));

export { useStyles };
